import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  padding: 20px;
  background-color: #222;
  color: white;
`;

const NavMenu = styled.div`
  display: flex;
  gap: 20px;
`;

const Navbar = () => {
  return (
    <Nav>
      <h1>MuseMatch</h1>
      <NavMenu>
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        <Link to="/terms">Terms</Link>
        <Link to="/contact">Contact</Link>
      </NavMenu>
    </Nav>
  );
};

export default Navbar;
